import {
  ACTION_CHANNELS_SET,
  ACTION_CHANNELS_UPDATE,
  ACTION_CHANNELS_ADD,
  ACTION_CHANNELS_REMOVE,
  ACTION_CHANNELS_CONNECTION_STATE,
  ACTION_CHANNELS_CURRENT,
} from "../actions/actionTypes";

const CHANNEL_STORAGE_KEY = "channel-storage";

function loadPersistedChannels() {
  try {
    const raw = localStorage.getItem(CHANNEL_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    }
  } catch (e) {
    // ignore
  }
  return null;
}

function persistChannels(channels) {
  try {
    if (channels && Array.isArray(channels)) {
      localStorage.setItem(CHANNEL_STORAGE_KEY, JSON.stringify(channels));
    }
  } catch (e) {
    // ignore
  }
}

const initialState = {
  channels: loadPersistedChannels() || [],
  channelsData: {},
  isConnected: false,
  isLoading: false,
  currentChannelId: null,
};

export const channelReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_CHANNELS_SET: {
      const channels = (action.channels || []).map((c) => ({
        ...c,
        id: String(c.id),
        unread: Number(c.unread) || Number(c.unread_count) || 0,
      }));
      persistChannels(channels);
      return { ...state, channels };
    }

    case ACTION_CHANNELS_UPDATE: {
      const { id, ...updates } = action.channel || {};
      if (!id) return state;
      const idStr = String(id);
      const channels = state.channels.map((c) =>
        String(c.id) === idStr ? { ...c, ...updates, id: idStr } : c
      );
      persistChannels(channels);
      return { ...state, channels };
    }

    case ACTION_CHANNELS_ADD: {
      const channel = action.channel;
      if (!channel) return state;
      const idStr = String(channel.id);
      const exists = state.channels.some((c) => String(c.id) === idStr);
      const channels = exists
        ? state.channels.map((c) =>
            String(c.id) === idStr ? { ...c, ...channel, id: idStr } : c
          )
        : [...state.channels, { ...channel, id: idStr }];
      persistChannels(channels);
      return { ...state, channels };
    }

    case ACTION_CHANNELS_REMOVE: {
      const channelId = String(action.channelId || "");
      const channels = state.channels.filter(
        (c) => String(c.id) !== channelId
      );
      persistChannels(channels);
      return { ...state, channels };
    }

    case ACTION_CHANNELS_CONNECTION_STATE:
      return {
        ...state,
        ...(action.isConnected !== undefined && { isConnected: action.isConnected }),
        ...(action.isLoading !== undefined && { isLoading: action.isLoading }),
        ...(action.channelsData !== undefined && { channelsData: action.channelsData }),
      };

    case ACTION_CHANNELS_CURRENT:
      return {
        ...state,
        currentChannelId: action.channelId != null ? String(action.channelId) : null,
      };

    default:
      return state;
  }
};
